import React, { memo, Suspense, useState } from 'react';
import { useDispatch } from 'react-redux';
import useFetchClients from '../../hooks/clients/useFetchClients';
import { setSelectedClientAction } from '../../redux/actions/clientsActions';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import ClientsTable from './ClientsTable';
import UpdateClientModal from './modals/UpdateClientModal';
import VehicleClientModal from './modals/VehicleClientModal';

const ClientsList = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { loading, clients, refresh } = useFetchClients({ unpaged: false });
  const [showUpdateClientModal, setShowUpdateClientModal] = useState(false);
  const [showVehiclesClientModal, setShowVehiclesClientModal] = useState(false);

  const handleClientClick = async (client) => {
    await dispatch(setSelectedClientAction(client));
    setShowUpdateClientModal(true);
  };

  const handleUpdateClientModalSubmit = async () => {
    refresh();
    setShowUpdateClientModal(false);
  };

  const handleClientVehiclesClick = async (client) => {
    await dispatch(setSelectedClientAction(client));
    setShowVehiclesClientModal(true);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        {showUpdateClientModal && (
          <UpdateClientModal
            readOnly={readOnly}
            onModalSubmit={() => handleUpdateClientModalSubmit()}
            onModalClose={() => setShowUpdateClientModal(false)}
          />
        )}
        {showVehiclesClientModal && <VehicleClientModal onModalClose={() => setShowVehiclesClientModal(false)} />}
        <>
          <ClientsTable
            onClientClick={handleClientClick}
            onClientVehiclesClick={handleClientVehiclesClick}
            clients={clients}
            readOnly={readOnly}
            loading={loading}
          />
          {clients.length === 0 && !loading && <EmptyContent title={'Список клієнтів порожній'} />}
        </>
      </div>
    </Suspense>
  );
};

export default memo(ClientsList);
